import ItiLanguageSelectorLogin from "@/iti-core-react/components/ItiLanguageSelectorLogin/ItiLanguageSelectorLogin";
import DarkModeToggle from "@/shared/components/DarkModeToggle/DarkModeToggle";
import { useThemeConfig } from "@/shared/contexts/ThemeConfigContext";
import { setNavigationBlocked } from "@/store/navigationBlock/navigationBlockActions";
import ScrollView from "devextreme-react/cjs/scroll-view";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import CardLogin from "../CardLogin/CardLogin";
import FooterFinancing from "../FooterFinancing/FooterFinancing";
import WelcomeSign from "../WelcomeSign/WelcomeSign";
import("./Login.scss");

export default function Login() {
	const dispatch = useDispatch();
	const { centeredLogin } = useThemeConfig();

	useEffect(() => {
		dispatch(setNavigationBlocked(false));
	}, []);

	return (
		<ScrollView height={"100%"}>
			<div
				className={
					centeredLogin
						? "container login-container-simple"
						: "container login-container"
				}
			>
				<div className="row d-flex justify-content-end ">
					<div className="col-12 d-flex justify-content-end align-items-center gap-3 language-selector-login">
						<DarkModeToggle />
						<ItiLanguageSelectorLogin />
					</div>
				</div>
				<div className="row welcome-texts-and-kpis-container gx-5">
					{!centeredLogin && (
						<div className={"col-md-7 col-12 welcome-texts-and-kpis"}>
							<WelcomeSign />
						</div>
					)}
					<div
						className={
							centeredLogin
								? "col-12 card-login-container"
								: "col-md-5 card-login-container"
						}
					>
						<CardLogin />
					</div>
				</div>
				<FooterFinancing />
			</div>
			<div className="app-version">
				<div>{import.meta.env.VITE_VERSION}</div>
			</div>
		</ScrollView>
	);
}
